"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTION_COLUMN_CONFIG_STORAGE = exports.ORDERS_COLUMN_CONFIG_STORAGE = exports.CUSTOMERS_COLUMN_CONFIG_STORAGE = exports.REWARD_TRACKS_COLUMN_CONFIG_STORAGE = exports.CHALLENGES_COLUMN_CONFIG_STORAGE = exports.BADGES_COLUMN_CONFIG_STORAGE = exports.VIEWED_ORDER_IDS_STORAGE = exports.REDIRECT_ROUTE = exports.NEW_CHANNEL_LOCAL_STORAGE = exports.HERO_CONNECT_USER_LOCAL_STORAGE = exports.USER_LOCAL_STORAGE = void 0;
exports.USER_LOCAL_STORAGE = "user_local_storage";
exports.HERO_CONNECT_USER_LOCAL_STORAGE = "hero_connect_user_local_storage";
exports.NEW_CHANNEL_LOCAL_STORAGE = "new_channel_local_storage";
exports.REDIRECT_ROUTE = "redirect_route";
exports.VIEWED_ORDER_IDS_STORAGE = "viewed_order_ids_storage";
exports.BADGES_COLUMN_CONFIG_STORAGE = "badges_column_config_storage";
exports.CHALLENGES_COLUMN_CONFIG_STORAGE = "challenges_column_config_storage";
exports.REWARD_TRACKS_COLUMN_CONFIG_STORAGE = "reward_tracks_column_config_storage";
exports.CUSTOMERS_COLUMN_CONFIG_STORAGE = "customers_column_config_storage";
exports.ORDERS_COLUMN_CONFIG_STORAGE = "orders_column_config_storage";
exports.TRANSACTION_COLUMN_CONFIG_STORAGE = "transaction_column_config_storage";
